export default __webpack_public_path__ + "static/media/p2-accessory.9bbfad7a.svg";